/**
 * Two people entered as one guest ("Hari & Prabha") are accepted at write time but rejected by the
 * RSVP lookup in app-server-api `findPerson`, so that guest can never find their invitation (LGL-60).
 * Like the legacy guest-list `regexForAndName`, this matches the *delimiter pattern* (a space-padded
 * `&`, `+` or `and`), never the bare character — "A&M" or a non-Latin name containing `&` is one
 * person. Case-insensitive on purpose ("Hari AND Prabha" is still two people). English-only, like the server.
 */
const GUEST_DELIMITER = /\s(?:&|\+|and)\s/i;

/** Empty values are "safe" here — required-ness is a separate rule. */
export const isSingleGuestName = (value: string | undefined): boolean => !value || !GUEST_DELIMITER.test(value);
